import { ORGANIZATIONCONTACT } from "_constants/OrganizationContactAPI";
import axios from "axios";

const { GET, POST } = require("_helpers/Fetch");

export const organizationcontactService = {
    GetCompanyContacts,
    UpdateCompanyContacts,
    ExportAll
}

async function GetCompanyContacts(bid) {
    try {
        const { data: CompanyContacts } = await GET(ORGANIZATIONCONTACT + "GetCompanyContacts/" + bid);
        return CompanyContacts;
    } catch (err) {
        return null;
    }
}

async function UpdateCompanyContacts(bid, updateCompanyContactDto) {
    try {
        const { data: Response } = await POST(ORGANIZATIONCONTACT + "UpdateCompanyContacts/" + bid, updateCompanyContactDto);
        return Response;
    } catch (err) {
        return null;
    }
}

async function ExportAll() {
    return axios.get(ORGANIZATIONCONTACT + "ExportAll", { responseType: "blob" });    
}